/**
 * 团队版会员版本注册表（对外稳定入口）
 * 新增版本档位时：在此注册元数据 + 在 teamPricing.ts 补价格行，调用方无需改动
 */

/** 团队版会员版本标识，与下单接口 memberType 字段一致 */
export type TeamMemberVersion = "pro" | "plus" | "ultra";

export interface TeamVersionMeta {
  value: TeamMemberVersion;
  /** 展示名：标准版/专业版/旗舰版 */
  label: string;
  /** 埋点与订单类型文案用短名：标准/专业/旗舰 */
  shortLabel: string;
  /** 每人每月算力（用于「团队合计总算力」联动展示） */
  monthlyPower: number;
  /** 每人云空间，单位 GB（用于「云空间」联动展示） */
  spaceGB: number;
}

export const TEAM_VERSION_REGISTRY: Record<TeamMemberVersion, TeamVersionMeta> = {
  pro: { value: "pro", label: "标准版", shortLabel: "标准", monthlyPower: 3000, spaceGB: 20 },
  plus: { value: "plus", label: "专业版", shortLabel: "专业", monthlyPower: 9000, spaceGB: 80 },
  ultra: { value: "ultra", label: "旗舰版", shortLabel: "旗舰", monthlyPower: 20000, spaceGB: 500 }
};

/** 购买页版本按钮的渲染顺序 */
export const TEAM_VERSION_LIST: TeamVersionMeta[] = [
  TEAM_VERSION_REGISTRY.pro,
  TEAM_VERSION_REGISTRY.plus,
  TEAM_VERSION_REGISTRY.ultra
];

/**
 * 按 memberType 字符串取版本元数据
 * 边界收口：接口返回的脏值（free/空/未知）统一兜底为 pro，避免脏数据扩散到组件树
 */
export const getTeamVersionMeta = (value?: string | null): TeamVersionMeta => {
  return TEAM_VERSION_REGISTRY[value as TeamMemberVersion] ?? TEAM_VERSION_REGISTRY.pro;
};
